import { Widget } from '@sprinklr/stories/widget/Widget';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import {
    headerTunables,
    opacityTunables,
    labelTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    metaInfoTunables,
    metricGroupTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';

export const HyperSpaceTreeMapWidgetTunables = (widget: Widget): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Tree Map'),
            startOpen: true,
        } as CollapseProps,
        children: [...headerTunables(widget), labelTunables(widget), opacityTunables(widget)],
    },
    metaInfoTunables({ widget, color: true, image: false }),
    metricGroupTunables(widget),
];
